
const useContent={
  hands:{n:'01',title:'A reusable addition to hand hygiene',body:'Roll the clean wand between your hands and fingers for 1–2 minutes. Copper Rescue® complements—not replaces—regular handwashing with soap and water.'},
  sores:{n:'02',title:'Care at the first tingling sensation',body:'The manufacturer recommends gently rubbing a clean wand over the tingling area for 2–4 minutes, before a blister appears. Review the full use instructions before beginning.'},
  skin:{n:'03',title:'A simple tool for minor skin care',body:'Copper Rescue® can be gently applied to minor cuts or certain skin concerns as directed. Do not use on serious wounds, and seek medical advice when needed.'},
  cold:{n:'04',title:'Add it to your early cold routine',body:'Copper Rescue® is designed for use at the earliest sign of cold symptoms. Carefully read the nasal use and safety directions on the official site before use.'}
};

document.querySelectorAll('.use-tab').forEach(tab=>tab.addEventListener('click',()=>{
  document.querySelectorAll('.use-tab').forEach(t=>{t.classList.remove('active');t.setAttribute('aria-selected','false')});
  tab.classList.add('active');tab.setAttribute('aria-selected','true');
  const content=useContent[tab.dataset.use];
  document.querySelector('.panel-count').textContent=content.n;
  document.getElementById('useTitle').textContent=content.title;
  document.getElementById('useBody').textContent=content.body;
}));

document.querySelectorAll('.gallery-thumb').forEach(button=>button.addEventListener('click',()=>{
  const image=document.getElementById('productImage');
  document.querySelectorAll('.gallery-thumb').forEach(b=>{b.classList.remove('active');b.setAttribute('aria-pressed','false')});
  button.classList.add('active');button.setAttribute('aria-pressed','true');
  image.style.opacity='0';
  window.setTimeout(()=>{image.src=button.dataset.image;image.alt=button.dataset.alt;image.style.opacity='1'},140);
}));

const reviews=[
  {text:'It’s a great tool. Cleans hands perfectly. Easy to use, store and carry. So glad to see a non-chemical based solution.',name:'Vickey M.'},
  {text:'I love the Copper Rescue so much I bought one for everyone in our family. We don’t go anywhere without our Copper Rescues.',name:'Susana L.'},
  {text:'It is easy to use, natural, and it fits in my purse. I recommend it to anyone looking to add to their wellness toolbox.',name:'Julie J.'}
];
let reviewIndex=0;
const dots=document.getElementById('reviewDots');
reviews.forEach((_,i)=>{const b=document.createElement('button');b.setAttribute('aria-label',`Show review ${i+1}`);b.addEventListener('click',()=>showReview(i));dots.appendChild(b)});
function showReview(i){reviewIndex=(i+reviews.length)%reviews.length;const r=reviews[reviewIndex];document.getElementById('reviewText').textContent=r.text;document.getElementById('reviewName').textContent=r.name;document.getElementById('reviewInitial').textContent=r.name[0];[...dots.children].forEach((d,n)=>d.classList.toggle('active',n===reviewIndex))}
document.getElementById('prevReview').addEventListener('click',()=>showReview(reviewIndex-1));
document.getElementById('nextReview').addEventListener('click',()=>showReview(reviewIndex+1));
showReview(0);

// Keep every section visible immediately, including without animation support.
document.querySelectorAll('.reveal').forEach(el=>el.classList.add('visible'));

const query=window.location.search;
document.querySelectorAll('.purchase-link').forEach(link=>{
  if(query){const target=new URL(link.href);const incoming=new URLSearchParams(query);incoming.forEach((value,key)=>{if(key.startsWith('utm_')||key==='gclid')target.searchParams.set(key,value)});link.href=target.toString()}
  link.addEventListener('click',()=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'purchase_cta_click',product:'Copper Rescue',value:49.99,currency:'USD'})});
});

